// extracted by mini-css-extract-plugin
export default {"floorBtn":"FloorBtn_floorBtn__6JL+F","bannerButton":"FloorBtn_bannerButton__Bhh-j"};